<script setup lang="ts">
definePageMeta({
  layout: 'blank',
});

const { isAuthenticated } = storeToRefs(useAuthStore());
const { closeModal, setAuthInitialTab } = useLayoutStore();
const {
  isCompleteRegulatoryRegisterEnabled,
  isRegulatorySimplifiedRegisterEnabled,
} = useAuth();

const showRegulatoryRegister = computed(
  () =>
    isCompleteRegulatoryRegisterEnabled.value ||
    isRegulatorySimplifiedRegisterEnabled.value,
);

const closeModalOrGoToHome = () => {
  if (window.self !== window.top) {
    closeModal();
    window.parent.postMessage('closeModal');

    return;
  }

  navigateTo(localeLink('/'));
};

watchEffect(() => {
  if (isAuthenticated.value) {
    nextTick(() => {
      closeModalOrGoToHome();
    });
  }
});

onMounted(() => {
  if (showRegulatoryRegister.value) {
    if (window.self !== window.top) {
      window.parent.postMessage('iframeLoading');
    }

    return;
  }

  // Redirecionar para o fluxo de login com aba de registro selecionada
  try {
    setAuthInitialTab?.('register');
  } catch {}

  if (window.self === window.top) {
    navigateTo(localeLink('/login'));
  } else {
    window.parent.postMessage('iframeLoading');
    navigateTo(localeLink('/login'));
  }
});
</script>

<template>
  <AuthPageLayout v-if="showRegulatoryRegister">
    <AuthRegisterCompleteRegulatory />
  </AuthPageLayout>
</template>
